import { SectorModel } from "types";

// Sector Backgrounds
import bgFixedImageCoreHorizon from "assets/bg-fixed-core-horizon.png";
import bgFixedImageMeridian from "assets/bg-fixed-meridian.png";
import bgFixedImageSanctum from "assets/bg-fixed-sanctum.png";
import bgFixedImageUnderhaven from "assets/bg-fixed-underhaven.png";
import bgFixedImageVale from "assets/bg-fixed-vale.png";
import bgMovingImageMeridian from "assets/bg-moving-meridian.png";
import bgMovingImageSanctum from "assets/bg-moving-sanctum.png";
import bgMovingImageUnderhaven from "assets/bg-moving-underhaven.png";
import bgMovingImageVale from "assets/bg-moving-vale.png";
import bgSlowImageCoreHorizon from "assets/bg-slow-core-horizon.png";
import bgSlowImageSanctum from "assets/bg-slow-sanctum.png";
import bgSlowImageUnderhaven from "assets/bg-slow-underhaven.png";
import bgSlowImageVale from "assets/bg-slow-vale.png";
import fgImageMeridian from "assets/fg-meridian.png";
import fgImageVale from "assets/fg-vale.png";

// Background Ships
import bgShipSpeederSenecaImage from "assets/bg-ship-speeder-seneca.svg";
import bgShipTramSenecaImage from "assets/bg-ship-tram-seneca.svg";
import bgShipTransporterSenecaImage from "assets/bg-ship-transporter-seneca.svg";

const SENECA_SECTORS: Record<string, SectorModel> = {
  vale: {
    slug: "vale",
    name: "Vale",
    planet: "seneca",
    backgroundFixedImage: bgFixedImageVale,
    backgroundSlowImage: bgSlowImageVale,
    backgroundMovingImage: bgMovingImageVale,
    foregroundImage: fgImageVale,
    backgroundFixedShips: [
      {
        image: bgShipTramSenecaImage,
        duration: 15,
        height: 6,
        verticalPosition: 15,
        isMovingRight: false,
      },
      {
        image: bgShipSpeederSenecaImage,
        duration: 10,
        height: 6,
        verticalPosition: 40,
        isMovingRight: true,
      },
      {
        image: bgShipTransporterSenecaImage,
        duration: 12,
        height: 6,
        verticalPosition: 28,
        isMovingRight: false,
      },
    ],
    backgroundSlowShips: [
      {
        image: bgShipTransporterSenecaImage,
        duration: 40,
        height: 10,
        verticalPosition: 45,
        isMovingRight: false,
      },
      {
        image: bgShipTramSenecaImage,
        duration: 35,
        height: 10,
        verticalPosition: 30,
        isMovingRight: true,
      },
      {
        image: bgShipSpeederSenecaImage,
        duration: 25,
        height: 10,
        verticalPosition: 60,
        isMovingRight: true,
      },
    ],
    backgroundMovingShips: [
      {
        image: bgShipTransporterSenecaImage,
        duration: 21,
        height: 18,
        verticalPosition: 46,
        isMovingRight: true,
      },
      {
        image: bgShipSpeederSenecaImage,
        duration: 14,
        height: 18,
        verticalPosition: 24,
        isMovingRight: false,
      },
      {
        image: bgShipTramSenecaImage,
        duration: 25,
        height: 18,
        verticalPosition: 70,
        isMovingRight: false,
      },
    ],
    npcs: ["vega"],
    mobs: [],
    buildings: ["senecaShipworks", "senecaPilotAcademy", "senecaJumpGate"],
    shipworks: "senecaShipworks",
    moveRange: 180,
    areaLeft: null,
    areaRight: "sanctum",
  },
  sanctum: {
    slug: "sanctum",
    name: "Haven",
    planet: "seneca",
    backgroundFixedImage: bgFixedImageSanctum,
    backgroundSlowImage: bgSlowImageSanctum,
    backgroundMovingImage: bgMovingImageSanctum,
    foregroundImage: "",
    backgroundFixedShips: [
      {
        image: bgShipTramSenecaImage,
        duration: 15,
        height: 6,
        verticalPosition: 15,
        isMovingRight: false,
      },
      {
        image: bgShipSpeederSenecaImage,
        duration: 10,
        height: 6,
        verticalPosition: 40,
        isMovingRight: true,
      },
      {
        image: bgShipTransporterSenecaImage,
        duration: 12,
        height: 6,
        verticalPosition: 28,
        isMovingRight: false,
      },
    ],
    backgroundSlowShips: [
      {
        image: bgShipTransporterSenecaImage,
        duration: 40,
        height: 10,
        verticalPosition: 45,
        isMovingRight: false,
      },
      {
        image: bgShipTramSenecaImage,
        duration: 35,
        height: 10,
        verticalPosition: 30,
        isMovingRight: true,
      },
      {
        image: bgShipSpeederSenecaImage,
        duration: 25,
        height: 10,
        verticalPosition: 60,
        isMovingRight: true,
      },
    ],
    backgroundMovingShips: [
      {
        image: bgShipTransporterSenecaImage,
        duration: 21,
        height: 18,
        verticalPosition: 46,
        isMovingRight: true,
      },
      {
        image: bgShipSpeederSenecaImage,
        duration: 14,
        height: 18,
        verticalPosition: 24,
        isMovingRight: false,
      },
      {
        image: bgShipTramSenecaImage,
        duration: 25,
        height: 18,
        verticalPosition: 70,
        isMovingRight: false,
      },
    ],
    npcs: ["lyra"],
    mobs: ["aven", "spectra", "radien", "graver", "wraeth"],
    buildings: [],
    moveRange: 220,
    areaLeft: "vale",
    areaRight: "underhaven",
  },
  underhaven: {
    slug: "underhaven",
    name: "Underhaven",
    planet: "seneca",
    backgroundFixedImage: bgFixedImageUnderhaven,
    backgroundSlowImage: bgSlowImageUnderhaven,
    backgroundMovingImage: bgMovingImageUnderhaven,
    foregroundImage: "",
    backgroundFixedShips: [
      {
        image: bgShipTramSenecaImage,
        duration: 15,
        height: 6,
        verticalPosition: 15,
        isMovingRight: false,
      },
      {
        image: bgShipSpeederSenecaImage,
        duration: 10,
        height: 6,
        verticalPosition: 40,
        isMovingRight: true,
      },
      {
        image: bgShipTransporterSenecaImage,
        duration: 12,
        height: 6,
        verticalPosition: 28,
        isMovingRight: false,
      },
    ],
    backgroundSlowShips: [
      {
        image: bgShipTransporterSenecaImage,
        duration: 40,
        height: 10,
        verticalPosition: 45,
        isMovingRight: false,
      },
      {
        image: bgShipTramSenecaImage,
        duration: 35,
        height: 10,
        verticalPosition: 30,
        isMovingRight: true,
      },
      {
        image: bgShipSpeederSenecaImage,
        duration: 25,
        height: 10,
        verticalPosition: 60,
        isMovingRight: true,
      },
    ],
    backgroundMovingShips: [
      {
        image: bgShipTransporterSenecaImage,
        duration: 21,
        height: 18,
        verticalPosition: 46,
        isMovingRight: true,
      },
      {
        image: bgShipSpeederSenecaImage,
        duration: 14,
        height: 18,
        verticalPosition: 24,
        isMovingRight: false,
      },
      {
        image: bgShipTramSenecaImage,
        duration: 25,
        height: 18,
        verticalPosition: 70,
        isMovingRight: false,
      },
    ],
    npcs: [],
    mobs: ["vexen", "behemal", "tracer", "volta", "reaver"],
    buildings: [],
    moveRange: 200,
    areaLeft: "sanctum",
    areaRight: "core_horizon",
  },
  core_horizon: {
    slug: "core_horizon",
    name: "Horizon",
    planet: "seneca",
    backgroundFixedImage: bgFixedImageCoreHorizon,
    backgroundSlowImage: bgSlowImageCoreHorizon,
    backgroundMovingImage: "",
    foregroundImage: "",
    backgroundFixedShips: [
      {
        image: bgShipSpeederSenecaImage,
        duration: 10,
        height: 6,
        verticalPosition: 40,
        isMovingRight: true,
      },
      {
        image: bgShipTransporterSenecaImage,
        duration: 12,
        height: 6,
        verticalPosition: 28,
        isMovingRight: false,
      },
    ],
    backgroundSlowShips: [
      {
        image: bgShipTramSenecaImage,
        duration: 35,
        height: 10,
        verticalPosition: 30,
        isMovingRight: false,
      },
      {
        image: bgShipSpeederSenecaImage,
        duration: 25,
        height: 10,
        verticalPosition: 60,
        isMovingRight: true,
      },
    ],
    backgroundMovingShips: [
      {
        image: bgShipTransporterSenecaImage,
        duration: 21,
        height: 18,
        verticalPosition: 46,
        isMovingRight: true,
      },
      {
        image: bgShipSpeederSenecaImage,
        duration: 14,
        height: 18,
        verticalPosition: 24,
        isMovingRight: false,
      },
    ],
    npcs: ["castor"],
    mobs: [],
    buildings: ["senecaVectorStation"],
    moveRange: 80,
    areaLeft: "underhaven",
    areaRight: "core_meridian",
  },
  core_meridian: {
    slug: "core_meridian",
    name: "Meridian",
    planet: "seneca",
    backgroundFixedImage: bgFixedImageMeridian,
    backgroundSlowImage: "",
    backgroundMovingImage: bgMovingImageMeridian,
    foregroundImage: fgImageMeridian,
    backgroundFixedShips: [],
    backgroundSlowShips: [],
    backgroundMovingShips: [],
    npcs: [],
    mobs: ["luxon", "phantes", "flaire", "calibra", "aethyr"],
    buildings: [],
    moveRange: 200,
    areaLeft: "core_horizon",
    areaRight: null,
  },
};

export default SENECA_SECTORS;
